"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:7.4.0'] && _();
}
catch (e) { }
